// extracted by mini-css-extract-plugin
module.exports = {"avatar":"index__avatar___PVsXo","image":"index__image___1hHSo","name":"index__name___AaWkm","small":"index__small___3tLPX","loading":"index__loading___3QcdM"};